module.exports = __webpack_public_path__ + "img/openApp.e7b66776.jpg";